module.exports = __webpack_public_path__ + "media/images/emblems/Rossemaison-e99bddb7d5d762b0f072e6ba11a7b380.png";